"use strict";

var isEqual = require('lodash/isEqual');

var difference = require('./difference');
/**
     * Gets the difference between the most recent version of a price table and an
     * object representing a new price table.
     *
     * I.E. Returns an object looking like:
     * { old: {}, new: { Mist: 5 } }
     * if a new entry was added to the price table with key Mist and value 5.
     *
     * @memberof! Pricing
     * @param {string} name Name of a price table.
     * @param {object} new_table Price table represented as an object.
     * @return {object} Difference between the two price tables, or null if no difference is found.
     * @throws {Error} When price_table can't be found.
     * @throws {Error} When either input is null or undefined.
     */


function diff(name, new_table, old_table) {
  // TODO:
  //  p.diff('_test_table_diff', { 0: undefined, 1: 'test', 2: 'test' });
  //  { old: { '0': 'test', '1': undefined, '2': undefined },
  //    new: { '0': undefined, '1': 'test', '2': 'test' } }
  //  diff doesn't detect if something was removed from old version.
  if (name == null || new_table == null) {
    throw new Error('Input cannot be undefined.');
  }

  var diff_new = difference(new_table, old_table);
  var diff_old = {};
  Object.keys(diff_new).forEach(function (key) {
    diff_old[key] = old_table[key];
  });

  if (isEqual(diff_old, {}) && isEqual(diff_new, {})) {
    return null;
  }

  return {
    old: diff_old,
    "new": diff_new
  };
}

module.exports = diff;